(() => {
  const setup = () => {
    const root=document.querySelector('.hh-header-preview .hh-header');
    const toggle=root?.querySelector('[data-hh-search-toggle]');
    const wrapper=root?.querySelector('.hh-search');
    if(!root||!toggle||!wrapper||root.dataset.previewSearchReady)return;
    root.dataset.previewSearchReady='true';
    const headerSection=root.closest('#shopify-section-header');
    const utility=document.querySelector('.hh-utility');
    let scrollPending=false;
    let directionStart=window.scrollY;
    let previousY=window.scrollY;
    let direction=0;
    const syncSticky=()=>{
      const y=Math.max(0,window.scrollY);
      const nextDirection=y>previousY?1:y<previousY?-1:direction;
      if(nextDirection!==direction){directionStart=previousY;direction=nextDirection;}
      headerSection?.classList.toggle('is-preview-stuck',y>(utility?.offsetHeight||0));
      const keepVisible=window.innerWidth>=1024||y<(utility?.offsetHeight||0)+(headerSection?.offsetHeight||0)||root.classList.contains('hh-is-drawer-open')||root.hasAttribute('data-preview-search-open')||root.querySelector(':focus-visible');
      if(keepVisible){
        headerSection?.classList.remove('is-preview-hidden');
        directionStart=y;
      }else{
        const threshold=direction>0?56:40;
        if(Math.abs(y-directionStart)>=threshold)headerSection?.classList.toggle('is-preview-hidden',direction>0);
      }
      document.documentElement.style.setProperty('--header-is-sticky',headerSection?.classList.contains('is-preview-hidden')?'0':'1');
      previousY=y;
      scrollPending=false;
    };
    window.addEventListener('scroll',()=>{if(!scrollPending){scrollPending=true;requestAnimationFrame(syncSticky);}},{passive:true});
    window.addEventListener('resize',syncSticky,{passive:true});
    root.addEventListener('focusin',()=>{headerSection?.classList.remove('is-preview-hidden');document.documentElement.style.setProperty('--header-is-sticky','1');});
    syncSticky();
    const close=(restore=false)=>{
      root.removeAttribute('data-preview-search-open');
      wrapper.classList.remove('is-visible');
      toggle.setAttribute('aria-expanded','false');
      if(restore)toggle.focus();
    };
    document.addEventListener('click',event=>{
      if(toggle.contains(event.target)){
        event.preventDefault();event.stopImmediatePropagation();
        if(root.hasAttribute('data-preview-search-open')){close(true);return;}
        root.querySelectorAll('[data-hh-trigger][aria-expanded=true]').forEach(button=>button.click());
        root.setAttribute('data-preview-search-open','');
        wrapper.classList.add('is-visible');
        toggle.setAttribute('aria-expanded','true');
        wrapper.querySelector('.search-bar__input')?.focus();
      }else if(!wrapper.contains(event.target))close();
    },true);
    document.addEventListener('keydown',event=>{
      const localeToggle=root.querySelector('.hh-drawer__locale-toggle[aria-expanded="true"]');
      if(event.key==='Escape'&&localeToggle){
        event.preventDefault();event.stopImmediatePropagation();
        localeToggle.click();
        localeToggle.focus({preventScroll:true});
        return;
      }
      if(event.key==='Escape'&&root.hasAttribute('data-preview-search-open')){event.preventDefault();event.stopImmediatePropagation();close(true);}
    },true);
    root.addEventListener('focusout',()=>requestAnimationFrame(()=>{if(!wrapper.contains(document.activeElement)&&!toggle.contains(document.activeElement))close();}));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
  document.addEventListener('shopify:section:load',setup);
})();
